import React, { useState } from 'react'
import SNav from '../../components/SNav';
import { Link, Outlet } from 'react-router-dom';
import MobileNav from '../../components/SNav/mobile';
import { GiShoppingBag } from "react-icons/gi";

const SHome = () => {
  return (
    <div className='h-screen'>
      {/* <div className='fixed h-screen w-full bg-[#141159] opacity-90 z-40'>
        <h1 className='text-white z-50 text-center mt-80 text-2xl'>Системийн шинэчлэл хийгдэж байна. Түр хүлээнэ үү</h1>
      </div> */}
      <div className='flex justify-center min-h-full font-Roboto'>
        <div className='xs:w-full md:w-[700px] bg-gray-100 flex justify-between bg-cover flex-col text-black shadow-2xl'>
            <div className='py-2 px-8 pb-24'>
              <div className='flex mt-2 justify-between'>
                  <div className='w-20'>
                      <MobileNav/>
                  </div>
                  <Link to="/">
                    <img src='../../logo.png' className='xs:h-20 md:h-32'/>
                  </Link>
                  
                  <Link className='w-20 flex justify-end' to="/cart-item">
                   <GiShoppingBag size={28} className='cursor-pointer'/>
                  </Link>
              </div>
              <h1 className='text-xl font-bold mt-2 uppercase text-center'>Сонголт карго дархан хот</h1>
              <Outlet/>
            </div>
            <SNav/>
        </div>
      </div>
    </div>
  )
}

export default SHome;
